module.exports = __webpack_public_path__ + "static/IMG_2464-aac18451a2f46e11cd96b85836e73e06.jpg";